import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Pagination';
import AdminResultsPerPageSelector from '../ResultsPerPageSelector';

class AdminPagesFooter extends PureComponent {
  render() {
    const {
      pagesTotal,
      page,
      perPage,
      handleChangePage,
      handleChangePerPage,
    } = this.props;

    return (
      <div className="table-footer">
        <AdminResultsPerPageSelector
          perPage={perPage}
          handleChangePerPage={handleChangePerPage}
        />
        <AdminPagination
          total={pagesTotal}
          page={page}
          perPage={perPage}
          handleChangePage={handleChangePage}
        />
      </div>
    );
  }
}

AdminPagesFooter.propTypes = {
  pagesTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default AdminPagesFooter;
